module.exports = __webpack_public_path__ + "img/120.a36a39ec.jpg";